import React from 'react';
import styles from './AiChatUsageWidget.module.scss';
import { BILLING_PLAN_UPDATED, useDateHelper, useLlmTokenUsageService } from 'nekst-api';
import { useDataLoaderNew } from 'data-loader';
import { LoadingAnimation } from 'ui-builder';

export default function AiChatUsageWidget() {
  const service = useLlmTokenUsageService();
  const dateHelper = useDateHelper();

  const { data } = useDataLoaderNew(
    service.getUsage,
    {
      events: [BILLING_PLAN_UPDATED],
    },
  );

  if (data) {
    const percent = Math.min(data.percentUsed, 100);
    const barWidth = Math.max(percent, 3);

    let grade = '';
    if (percent >= 95) {
      grade = styles.danger;
    } else if (percent >= 75) {
      grade = styles.warning;
    }

    return (
      <div className={styles.widget}>
        <div className={styles.graph}>
          <div className={`${styles.inner} ${grade}`} style={{ width: `${barWidth}%` }}>
            &nbsp;
          </div>
        </div>
        <div className={styles.text}>
          AI usage this month: {Math.round(percent)}%
        </div>
        <div className={styles.period}>
          Resets on {dateHelper.toString(data.periodEnd)}
        </div>
      </div>
    );
  } else {
    return <LoadingAnimation />;
  }
}
